import { render } from "./DistributorList.vue?vue&type=template&id=91341ef4&scoped=true"
import script from "./DistributorList.vue?vue&type=script&lang=js"
export * from "./DistributorList.vue?vue&type=script&lang=js"

import "./DistributorList.vue?vue&type=style&index=0&id=91341ef4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-91341ef4"

export default script